<template>
    <div class="page div">
        <div class="top div">
            <div class="top-back div" @click="toBuyPkg">
                <van-icon name="arrow-left div" />
            </div>
            <div class="top-name div">投诉详情</div>
        </div>
        <div class="body div">
            <div class="title div">投诉内容</div>
            <div class="e_txt div">若您遇到其他无法和卖家沟通解决的问题，您可点击下方“投诉卖家”，我们会协助您解决问题。</div>
            <div class="icon_done div"><img src="@/assets/user/28.png" alt=""></div>
            <template v-if="objData.disposeState === 2">
                <div class="status_desc div" style="flex-direction: row;justify-content: center;">
                    <div class="div">处理结果：<span style="color: red;">{{ objData.remark }}</span></div>
                </div>
            </template>
            <template v-else>
                <div class="status_txt div">已提交申请</div>
                <div class="status_desc div">
                    <div class="div">客服将在48小时内审核申请，</div>
                    <div class="n_flex div">剩余时间 :<van-count-down :time="time" /></div>
                </div>
                <div class="cardViewBottom">
                    <van-steps :active="active">
                        <van-step>已提交</van-step>
                        <van-step>审核通过</van-step>
                        <van-step>填写物流信息</van-step>
                        <van-step>确认退款</van-step>
                    </van-steps>
                </div>
            </template>
            <div class="footer-btn div">
                <van-button type="primary" style="background-color: #409eff;border-color:#409eff;" @click="customer">联系投诉客服</van-button>
            </div>
            <div class="footer-btn div">
                <van-button type="primary" @click="onceMore">再次投诉</van-button>
            </div>
        </div>
    </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast } from 'vant';
export default{
    data(){
        return{
            iccid: localStorage.getItem("iccid"),
            kefuUrl: localStorage.getItem("kefuUrl"),
            time: 48 * 60 * 60 * 1000,
            active:0,
            objData:{}
        }
    },
    created(){
        this.init()
    },
    methods:{
        toBuyPkg(index){ 
            this.$router.push({
                path: "/user/complaintHistory",
            });
        },
        onceMore(){
            this.$router.push({
                path: "/user/entrance",
            });
        },
        customer(){
            window.location.href=this.kefuUrl;
        },
        init(){
            wxRequest("/userProblem/userInfo", {iccid:this.iccid}, "post").then(res => {
                if(res.data.code === '200'){
                    if(res.data.data.resultList.length > 0){
                        res.data.data.resultList.forEach(item=>{
                            if(item.id === this.$route.query.id){
                                this.objData = item
                                if(item.disposeState === 1){
                                    this.time = 48 * 60 * 60 * 1000
                                    this.active = 0
                                }else{
                                    this.time = 0
                                    this.active = 3
                                }
                            }
                        })
                        
                    }
                }else{
                    Toast.fail(res.data.message); 
                }
            })
        }
    },
}
</script>
<style lang="less" scoped>
.div{
    display: flex;
    flex-grow: 0;
    flex-basis: auto;
    align-items: stretch;
    flex-direction: column;
}
.page{
	height:100%;
	background: #f7f8fa;
    .top{
        flex-direction: row;
        align-items: center;
        height: 44px;
        background-color: #3bb272;
        .top-back{
            width:30px;
            align-items: center;
            text-align: center;
            position: absolute;
            height: 44px;
            line-height: 44px;
            justify-content: center;
            color: #fff;
            font-size:20px;
        }
        .top-name{
            text-align: center;
            font-size: 17px;
            color: #fff;
            flex: 1 1 0%;
        }
    }
    .body{
        box-sizing: border-box;
        padding: 10px;
        .title{
            font-size: 22px;
            border-bottom: 1px solid #eee;
            padding-bottom: 18px;
            margin-bottom: 25px;
        }
        .e_txt{
            font-size: 16px;
            color: #303133;
            line-height: 26px;
            margin-bottom: 50px;
        }
        .icon_done{
            margin: 0 auto;
            width: 40px;
            height: 40px;
            margin-bottom: 20px;
        }
        .status_txt{
            font-size: 17px;
            font-weight: 700;
            color: #303133;
            text-align: center;
            margin-bottom: 10px;
        }
        .status_desc{
            color: #8c9198;
            font-size: 12px;
            text-align: center;
            margin-bottom: 25px;
            .n_flex{
                text-align: center;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                .van-count-down{
                    color: #3bb272;
                    font-size: 12px;
                }
            }
        }
        .cardViewBottom{
            margin-top: 15px;
            margin-bottom: 50px;
            .van-steps{
                background: none;
            }
            ::v-deep .van-step--horizontal .van-step__icon{
                font-size:14px;
            }
            ::v-deep .van-step__circle{
                width:10px;
                height:10px;
            }
            ::v-deep .van-step__circle-container{
                background: none;
            }
            ::v-deep .van-step__line{
                height:2px;
                background: #ddd;
            }
        }
        .van-button{
            width:147px;
            height: 42px;
            border-radius: 4px;
            margin: 0 auto;
            margin-bottom: 15px;
        }
    }
}
</style>
